var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlha(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "island",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 716.86 476.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-4 {\n        fill: #777;\n      }\n\n      .cls-18,\n      .cls-5 {\n        opacity: 0.15;\n      }\n\n      .cls-26,\n      .cls-27,\n      .cls-5,\n      .cls-7 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-6 {\n        fill: #514525;\n      }\n\n      .cls-7 {\n        opacity: 0.38;\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-8 {\n        fill: #d8dba2;\n      }\n\n      .cls-9 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-10 {\n        fill: #8e9e29;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-12 {\n        opacity: 0.35;\n      }\n\n      .cls-13 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-14 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-19 {\n        fill: #474747;\n      }\n\n      .cls-20 {\n        fill: #5e5e5e;\n      }\n\n      .cls-21 {\n        fill: #ededed;\n      }\n\n      .cls-22 {\n        fill: #fff;\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-26 {\n        opacity: 0.17;\n      }\n\n      .cls-27 {\n        opacity: 0.13;\n      }\n\n      .cls-28 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-29 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-30 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-31 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-32 {\n        fill: url(#radial-gradient-13);\n      }\n\n      .cls-33 {\n        fill: #8fad66;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 347.21,
    cy: 320.12,
    r: 60.8,
    gradientTransform: "matrix(1, -0.09, -0.09, -1, -20.13, 398.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#436332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8fad66"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 403.51,
    cy: 283.86,
    r: 88.89,
    gradientTransform: "matrix(1, 0, 0, -1, -64.51, 379.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#436332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5f7e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#82a05d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fad66"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 422.74,
    cy: -927.19,
    r: 349.77,
    gradientTransform: "matrix(1, 0, 0, -0.14, -64.59, 291.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c1930",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c1930",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 456.06,
    cy: 18.01,
    r: 94.2,
    gradientTransform: "matrix(1, 0, 0, -1, -64.51, 379.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 424.37,
    cy: 212.78,
    r: 114.03,
    gradientTransform: "matrix(1, 0, 0, -1.94, -64.51, 650.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 364.89,
    cy: 310.62,
    r: 66.52,
    gradientTransform: "matrix(1, 0, 0, -1, -64.51, 379.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 334.42,
    y1: 81.59,
    x2: 329.9,
    y2: 73.07,
    gradientTransform: "matrix(1, -0.1, -0.1, -1, -40.7, 397.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 394.49,
    cy: 137.25,
    r: 40.97,
    gradientTransform: "matrix(1, 0.07, 0.1, -1.48, -85.58, 471.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 318.95,
    cy: 11.33,
    r: 31.75,
    gradientTransform: "matrix(1, 0, 0, -1, -64.51, 379.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 413.92,
    y1: 67.17,
    x2: 408.12,
    y2: 81.18,
    gradientTransform: "matrix(1, 0, 0, -1, -64.51, 379.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c1930",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c1930",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 305.96,
    y1: 5.82,
    x2: 297.02,
    y2: 30.7,
    gradientTransform: "matrix(1, 0, 0, -1, -64.51, 379.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#cacaca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 312.32,
    y1: -80.28,
    x2: 336.71,
    y2: 31.03,
    gradientTransform: "matrix(1, 0, 0, -1, -64.51, 379.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 303.66,
    y1: 205.87,
    x2: 308.84,
    y2: 205.87,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 477.98)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 302.66,
    y1: 206.11,
    x2: 309.56,
    y2: 206.11,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 477.98)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 333.4,
    y1: 86.9,
    x2: 359.08,
    y2: 86.9,
    gradientTransform: "matrix(1, -0.1, -0.1, -1, -40.7, 397.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 198.33,
    cy: 257.27,
    r: 60.8,
    gradientTransform: "matrix(0.68, -0.74, -0.74, -0.68, 334.06, 389.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a7a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#989c63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a9ad6e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 315.37,
    cy: 267.55,
    r: 129.11,
    gradientTransform: "matrix(1, 0, 0, -1, -64.51, 379.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#436332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#476735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5f7e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#708e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7a9858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7d9b5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#86a460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8fad66"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 400.18,
    cy: 278.73,
    r: 88.28,
    gradientTransform: "matrix(1, 0, 0, -1, -64.51, 379.09)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 369.37,
    cy: 314.82,
    r: 67.81,
    gradientTransform: "matrix(1, 0, 0, -1, -64.51, 379.09)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 191.12,
    cy: 113.11,
    r: 55.76,
    gradientTransform: "matrix(0.67, -0.74, -0.43, -0.39, 204.26, 232.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-filter",
    x: "-500%",
    y: "-500%",
    width: "1000%",
    height: "1000%"
  }, /*#__PURE__*/React.createElement("bx-title", null, "Drop Shadow"), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 1,
    result: "gaussian-blur-0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "waves",
    dx: 5,
    dy: 5,
    in: "gaussian-blur-0",
    result: "offset-0"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    result: "offsetblur",
    in: "offset-0"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    id: "spread-ctrl",
    type: "linear",
    slope: 1.96
  })), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255,255,255,0.5)",
    result: "flood-0"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in",
    result: "composite-0",
    in: "flood-0"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "merge-0"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "composite-0"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1 folha-5",
    d: "M338.57,30.42,337,45.35l-6.71-9.64,3.05,12L324.74,56l-4.56-14.14,1.51,16.43s-4,9.36-4.14,7.43-4.48-3-4.48-3l.16,18.79-7.74.72,2.76-22.74-4.67,2,1.69-13.19L299.37,53l-3.88-16.38,7.13-6.8,19-7.9Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2 folha-6",
    d: "M338.57,52.09l40.31,15.67-4.67,46.41L363.56,99l2.1,19.12-13,9.58-9.28-16.17,3.45,21.61H331.66v-10.4l-5.39,10.4s-9.65,9.59-10.11,8.06-1.57-13.45-1.57-13.45l-5,13.62-11.4,7.34,6.17-28.75,7.17-2.39.07-8.4,5.45-15.56,17.07-3.25-12-4.77Z",
    transform: "translate(0 -0.02)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 358.43,
    cy: 420.7,
    rx: 358.43,
    ry: 55.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M474.43,392.75c1-.29,15.16-32.71,11-40.26S442.31,310.18,430,310.88s-42.51,5.46-44.12,12.61-23.83,42.88-22.24,46.85S416.06,409.6,474.43,392.75Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M385.88,323.49s15.68,22.15,34.52,10.59,10.87,3.34,10.87,3.34,14.57,17.6,31.9,13.36,22.22,1.71,22.22,1.71,1.77,35.87-22.55,36.66S395,396.31,390,382.24,385.88,323.49,385.88,323.49Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.66,102.36s71.55,201.42,29.83,251.73,64.22,14.29,64.22,14.29S385.8,221.64,322.07,85.49C304.49,48,303.66,102.36,303.66,102.36Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M303.66,102.36s71.55,201.42,29.83,251.73,64.22,14.29,64.22,14.29S385.8,221.64,322.07,85.49C304.49,48,303.66,102.36,303.66,102.36Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sand-animated",
    className: "cls-8",
    d: "M169.11,393c8.3-7.49,84.55-15.63,109.55-41.63,12.34-12.83,61-15,71-10s70,31,84,30,94,0,104,7,36.07,16,19.44,24.3c-26.89,13.47-71.75,15.83-154.25,14.92-29.61-.33-117.6,6.8-136.07,7.19-47,1-119.27-12.21-100-29.57Z",
    transform: "translate(0 -0.02)",
    filter: "url(#drop-shadow-filter)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sand-low",
    className: "cls-8",
    d: "M136.66,403.36C144.96,395.87,253.66,377.36,278.66,351.36C291,338.53,340,336.36,350,341.36S419.66,372.36,433.66,371.36S527.66,371.36,537.66,378.36S605.41,408.97,588.74,417.36C561.85,430.83,486.16,440.36,403.66,439.36C374.05,439.04,279.1,438.97,260.66,439.36C213.66,440.36,117.42,420.73,136.66,403.36Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sand-high",
    className: "cls-8",
    d: "M176.85,392.64C185.15,385.15,253.66,377.36,278.66,351.36C291,338.53,339.66,336.36,350,341.36S420,372.36,433.66,371.36S527.66,371.36,537.66,378.36S581.57,394.98,564.94,403.36C538.05,416.83,497.46,418.36,403.63,414.75C374.02,414.42,288.02,418.6,269.55,420.75C222.54,421.73,157.61,410.00,176.85,392.64Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298.16,85.39s12.33,35.32,19.8,61.7c-6.39-20.88,13.7-51.53,21.75-20.52-12.85-36.33-23.55-51.22-23.55-51.22l-6.32-3.06Z",
    transform: "translate(0 -0.02)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M269.92,283.76c2.46,3.79,15.6,9.55,24,9.17-3,8.53-16,31.64-16,31.64s-16.8-.82-15.93-3S269.92,283.76,269.92,283.76Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M270.66,279.75c1.52-1.26,20.36,4.35,24.4,9.28,2.34,2.85-1.16,3.9-1.16,3.9s-15.57.11-24-9.17C268,281.64,270.66,279.75,270.66,279.75Z",
    transform: "translate(0 -0.02)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204,381.31s28.27,6.4,30.2,12.72S233,411.31,233,411.31s9.06-6.37,18.3-14c13.53-11.22,31.72-13.22,60.3-11.74,14.23.72,61-.66,66.8-11.44s7.38-16.09,11.49-15.63c-4.54-2-8.48-3.37-12.26-4.94,2.51-8.25,3.66-30.59,1.73-38s-24.08-33-21-44.36,10.49-17.1,5.21-24.39-12.27-18.74-22.9-12.5-3.05,60,2,74.51-2.45,55.44-16,54-39.19-11.66-50-11.11C274.66,359.25,234.21,374.22,204,381.31Z",
    transform: "translate(0 -0.02)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M253.81,335.2c-3.31-1.16-1.73-6,8.27-15s47.08,1.49,54.08-8.51,11.42-32.49,20.92-34.49,21-2,27.58,17.81c6.39,19.08,5.43,26.83,3.43,40.83-1.92,13.46-6.12,28.8-25,36.36C268.08,402.16,279.66,344.26,253.81,335.2Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M253.81,335.2c-3.31-1.16-1.73-6,8.27-15s47.08,1.49,54.08-8.51,11.42-32.49,20.92-34.49S357,275.57,364.66,295c7.6,19.21,6.56,26.74,5,41.55-1.44,13.53-7.66,28.08-26.55,35.64C268.08,402.16,279.66,344.26,253.81,335.2Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M341.27,316.47s16.75-4.93,16.41-5.6S356.5,295,356.5,295l-10.2-4.4s-17.23,5.12-17.23,5.48,5.8,14.82,5.8,14.82Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M204,381.31s2.26,3.07,15.26-1.93c16.88-6.49,17.32-7.55,17.32-7.55-9-20-.26-41.64,13.68-37.45,20,6,15.32-16,7-20-23-11-36,13-38,41C218.56,365.29,209.72,365,204,381.31Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M307.05,380.71s-42,4.53-60.08,16.6a49.39,49.39,0,0,0-14,14s-9,6-14-3c-5.87-10.56-10-24.15-8-31s18,9,18,9a238.11,238.11,0,0,1,50.69-28.13c2.39-1,10.51-5,9.55-13C304.73,331,345.49,368.42,307.05,380.71Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.06,314.23c4.45-.23,22.76,12.95,16.75,21,4,3.68,10.6,3.68,20.74,25.14,23.61-10,5.82-31.57,41.81-37.37,5.44-.88,15.81-1.93,21.41-1,11.6,1.86,25.18,43.34-6.11,54.33,44.41-8.09,38.75-60.66,35.89-71.58-1.33-5.05-4.7-21.06-14.62-26.27-10.57-5.56-22.89,1.15-26.66,11.7,16.7,5.69,26-11,33.73-3.87,6.46,6-3.87,28.29-3.87,28.29L311.57,317s-63.68-9.9-64.4-10.14S237.06,314.23,237.06,314.23Z",
    transform: "translate(0 -0.02)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "221.66 307.84 221.66 299.34 275.41 299.34 331.66 314.13 331.66 319.88 279.66 331.84 221.66 307.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "207.28 299.34 183.66 245.84 185.66 238.84 263.66 254.84 279.66 321.84 276.66 325.84 207.28 299.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M352.66,292.36c-.82,3.08,4.08,22.25-10,16.51s-31-19.51-40-17.51c-10.51,2.34-20.93,9.75-13,14,4.27,2.29,13-6.94,15-3,.46.9,1.56,5.25,4,6,9.67,2.85,23.76,5.36,23,5.79v5.75l-8.25,1.9s9.93,3.25,24.25,1.56c17-2,18-19.66,18-19.66C365.66,287.09,353.66,283.36,352.66,292.36Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M293.66,229.36l-5.31,35.25c4,1.8,12.11,1.69,14.31.75,2.48-1,1,15,8,18s16.61-5.5,23.5-11.5,11,0,18.5-28.5c0-16.15-14-46-41-37C295.1,211.89,293.66,229.36,293.66,229.36Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.66,234.36c-.39,2.23-.5-4.1,5.5-3.5s7,9,3,15c-2,2.94-6.5-.5-6.5-.5s.11,3.42,0,5c-1.35,20-15.36,6.84-32,13,13,4,15,13,7,17-7,3.5-11.59,1.39-10.26-16.33-2.18.62-4.06,1.22-4.74,1.33,1,8,.25,13.5,1,18,.9,5.38,5.3,8,9,7s7.42.24,13-4,6.21-2,12.11-6,8.89-2,10.89-5,4-3.5,4-10-5-12.45,0-14.45c3.38-1.35,7.3-12.07,5-15.55s1.08-6.63-1-12,3-6-2-10-1-4-11-6-4-3-9-7-5-2-11-2c-3-4-10-4-14,3-3-8-15-1-13,7-9-2-7.69,6.8-7.69,6.8-6,1-8.68,7.6-2.31,12.2,5.85,4.22,10,1,11.94-3.5,5.06,3.5,8.06-.5,11.06-3.5,4.46,2.55,7,2,10,0,4,5,6.5,4.5,10,3,4.5-2.5,2.5,5.5,6.5,5.5,3,6,.5,7.5,2.5,7.5A2,2,0,0,0,340.66,234.36Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 311.57,
    cy: 240.93,
    r: 4.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.44,
    cy: 243.56,
    r: 3.28
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "308.84 280.57 303.66 276.56 303.66 265.1 308.78 263.66 308.84 280.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "309.56 280.33 303.33 276.32 302.66 265.34 309.49 263.41 309.56 280.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M282.94,283.3c.21,1.07,1.19,1.22,2.57.92,0,0,2.7-7.56,2.9-8,1.63-3.75,3.83-3.74,5-3.66s13.22.33,13.43-.28a12.34,12.34,0,0,1,.66-1.43l-12.09-.76a8,8,0,0,0-9,5.68C284.6,281.19,282.94,283.3,282.94,283.3Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.56,266.2s0,2.36-1.56,2-3.82-1.83-3.21.32,2.61,2.87,1,3.17c-.87.16-2.64,3.26-.38,2.95s2.17-2.08,2.39.29c.35,3.82,5.31,6.11,5.31,6.11s1-11.31,1.09-12.06S309.56,266.2,309.56,266.2Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M293.66,229.36l-.24,1.64s4.74,0,5.85-2.87c3.31.43,8.81-1.14,10.29-4.19,1.91,1.49,8,3.06,8.76-1,1.86,2.49,7.83,4.38,10.7,3.6a2.8,2.8,0,0,1,2.93.89c1.64,1.95,4,3.75,4.21,1.41.36-3.24.85-12.76-.62-13.74s-20.68,2-20.68,2l-21,4.89Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M341.82,240.3c.07.81,0-2.85.63-4.32a3.55,3.55,0,0,1,.51-.86c1.14-1.4,2.09-2.75,3.87-2s3.26,1.59,3.31,3.57a28.75,28.75,0,0,1-.66,4.7c0,.51,0-1.77-1-2.08s-2.46.82-2.46.82c-1.2,1.7-1.58-2.86-1.58-2.86a1.32,1.32,0,0,0-1.74.08A3.86,3.86,0,0,0,341.82,240.3Z",
    transform: "translate(0 -0.02)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28 folha-8",
    d: "M299.16,28.19,308,40.3l-11.44-2.65,10.31,6.87L306,56.41,293.15,49l12.14,11.18s3.32,9.59,1.9,8.29-5.31.8-5.31.8l12.71,13.84-5.26,5.72L296.14,70.09,294,74.69l-7.58-10.93-1.17,7.51-13.9-9.56.74-9.83,8.81-18.6Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29 folha-1",
    d: "M277,73.7s-92.85-55.08-167.47,44.07c-7.88,10.48-21.7,37.81-32.18,52.13,14.4-3.3,36.59-21.78,36.59-21.78l-3.64-16.52,15.23,7.82,30.6-21.27-14.2-18.36,21.85,11.87L193.86,99l3.29-20.9,17.34,19.36L237.1,99l4.57-23.78,10.62,21.44,19.89,5.11L277,86.26s26,19.33,26,16.43-6.87-18.36-6.87-18.36Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30 folha-9",
    d: "M322.07,85.49S324.66,66,339.83,66c10.3,0,10.85,19.47,10.85,19.47l19.71,9.67,12.47-36.73V99l22.32,19.33,12.68-34.79-4,40.59,16.54,24.16,22.12-24.16L438,159.91s5.8,4.83,5.8,20.29S464.11,158,464.11,158s-11.59,43.49-12.56,45.43-4.83,27.6-4.83,27.6,34.61-39.18,32.42-59.5C467,59.4,378.77,42,378.77,42c-65.29,0-62.71,30.93-62.71,30.93Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31 folha-2",
    d: "M296.94,73.77s-21-37.25-37.77-42.08-51.76,2.82-63.49,18.1c-14.79,19.27-22.2,55-24.78,78.55s-1.61,39.3-1.61,39.3l11.27-20.3-2.9-15.46s9.81,1.55,10.63,1c2.58-1.83,9.35-13.53,9.35-13.53l-10-14.82,18.28,1.15s7.17-21,7.81-22.41S204,70.7,204,70.7l21,2.63,13.83-12.61-8.7-13.53,13.25,12.9,17.11,1.56s3.2-12.56,2.25-11.59S264.35,62,264.35,62L275,64.87s4.59-5.79,4.71-4.83,8.69,14.57,8.69,14.57l9.78,13.48L303,91.63Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32 folha-3",
    d: "M234.85,172.47c-1-1.93,30.92-27.54,30.92-27.54L260,129.46l11.6,9.19,18.85-20.78L283,100.47l10.91,11.12,14.94-5.32-4.51-9.91,7.24,5.56,2.66-10.63-2.66-7.73-7.91-10.13s-11.17-20.34-25.72-13.55-23.28,30-23.28,30L262,82.63l-9.73,14L244,113.54l9.66-6-16.63,19-5.4,9.93,11.4-9-15,18.36-2.42,11.6,6-7.25s-4.09,9-7.29,16.17c-1.06,2.35-2,4.5-2.71,6.06-2.76,6.28-2.76,14.4-2.76,14.4l9.66-8.6-.48-6.77Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33 folha-9",
    d: "M378.84,111c-.59,41.87-8.74,30.08-8.74,30.08l-1.18,13-4.32,14s-7.64-10-5.86-8.53S356,171.06,356,171.06s-18.91,11.53-18.91,10,3.65-29.33,3.65-29.33l8.62-5.51-6.53-3.51,5.58-24.82,13.22-8.8H347l-5.72-22,19-13.18s-21.94.75-21.94-.76-6.79-7-6.79-7l-1-11L316,69.46l-7,11-5.35.5S380.93-35.91,378.84,111Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33 folha-4",
    d: "M247.89,90.26l20.86-12.17.05-7.38,6.89,4,18.19-13,1.4-20.82,3.59,15.2L319.7,45.72,318.28,28.3l8,17.86,15-8.22s-7.17-24.1-24.08-35.35S279,20.26,276.09,26.81a172.41,172.41,0,0,1-8.26,15.42l9.11-5.92-10.86,9.5-4.59,10.51,4.46-3.9-5.09,5.95L255.31,69l3.7-2.17-5.64,7Z",
    transform: "translate(0 -0.02)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlha);
export default __webpack_public_path__ + "static/media/ilha.d59bcd939de96d60b3b003a80be12cca.svg";
export { ForwardRef as ReactComponent };